import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable()

export class ActivityProcessFeedstockService {

    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getActivityProcessFeedstocks() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock');
    }

    getProductionActivities() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/productionactivities');
    }

    getSpecificProcesses() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/specificprocesses');
    }

    getFeedstocks() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/feedstocks');
    }

    getBusinessCategories() {
        return this.http.get<any[]>(this.baseurl + 'activityprocessfeedstock/businesscategories');
    }

    addActivityProcessFeedstocks(activityprocessfeedstock: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/addactivityfeedstock', activityprocessfeedstock);
    }

    updateActivityProcessFeedstocks(activityprocessfeedstock: any) {
        return this.http.post<any[]>(this.baseurl + 'activityprocessfeedstock/updateactivityfeedstock', activityprocessfeedstock);
    }
}